<template>
    <div class="app-content content devcontent ">
        <div class="content-overlay"></div>
        <div class="header-navbar-shadow"></div>
        <div class="content-wrapper">
            <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
                <div class="container-fluid">
                    <div class="row breadcrumbs-top">
                    <div class="col-md-12 content-header-left px-0">
                        <h3 class="content-header-title float-left mb-0" >  Dock Performance     </h3>
                       
                        <div class="breadcrumb-wrapper">
                        <ol class="breadcrumb">
                            
                            <li class="breadcrumb-item"><a href="#">Dashboard</a>
                            </li>
                            
                           
                           
                            
                            
                        </ol>
                    </div>
                    </div>
                    </div>
                </div>
            
            </div>
            <div class="content-body">
                <div class="modal fade" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                    <div class="modal-dialog   modal-dialog-centered">
                        <div class="modal-content">              
                        <div class="modal-body p-0">
                            <div class="view_photo_transaction"> 
                            <button type="button" class="close imageModalClose" data-dismiss="modal"><x-icon size="1.5x" class="custom-class avatar-icon font-medium-3"></x-icon></button>
                            <template v-for="(url, index) in photo_links">
                                <div class="view_photo_multiple"> 
                                <img :alt="'Photo'+index" :src="url" class="imagepreview"  >
                            </div>
                            </template>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
                <vue-element-loading :active="isLoading"  :is-full-screen="true"/>
               
                <section id="dashboard-ecommerce" class=" ">
                    <nav class="nav-tabs-wrapper main_divtabsview">
                        <ul class="tabs_masters_detailstabing_pills  nav nav-pills   nav-pill-primary  pt-1 nav-tabs-items dragscroll">
                            <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="activateReport">
                                <a class="nav-link active shadow-none" id="gate_tab" data-toggle="tab" href="#report" aria-expanded="true" >Gate Performance
                                </a>
                            </li>
                            <li class="nav-item tabs-item active main_divtabsviewtoggle" data-day="1" @click="deActivateReport">
                                <a class="nav-link shadow-none" id="dock_tab" data-toggle="tab" href="#chart" aria-expanded="true" >Docks Perfomance
                                </a>
                            </li>
                        </ul>
                    </nav>
                <div class="tab-content ">
                    <div role="tabpanel" class="tab-pane active global_performance_tab_container" id="report" aria-labelledby="gate_tab" aria-expanded="true">
                        <div class="row mx-0 match-height dshboard_margin_x customAnimation">
                            <div class="col-lg-12 col-12 dshboard_padd_x card p-0 mb-0">
                                <div class="jumbotron_bg dashboard_secondview px-1 pt-1 pb-0 white_bg">
                                <!-- <h4  class="customTitle pb-1 mb-0">Gate Details</h4> -->
                                <div class="row match-height dashTiles dashTiles_icons mb-0">
                                    <vue-element-loading :active="isGateMainPerformanceDataLoading" />
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-01" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/wait_time_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                        {{convertMinutesToTime2(mainGatePerformanceData.avg_gate_wait_time)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Min</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg Gate Wait Time</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-02" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/parking_wait_time_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{convertMinutesToTime2(mainGatePerformanceData.avg_parking_wait_time)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Min</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg. Parking Wait Time</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-03" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exist_tat.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainGatePerformanceData.avg_gate_entry_to_gate_exit_tat)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Hours</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg Gate Entry To Gate Exit TAT</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2" style="display: none;">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-01" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{roundNumber(mainGatePerformanceData.parking_capacity)}}%
                                                </span>
                                                <span class="avgGatetimeMi"> Occupied</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Parking Capacity</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-04" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainGatePerformanceData.daily_avg_gate_entry)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Daily Avg. Gate Entry</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-05" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainGatePerformanceData.daily_avg_gate_exit)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Daily Avg. Gate Exit</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-06" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainGatePerformanceData.avg_trucks_in_parking)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg. Trucks in Parking</h2>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                </div>
                            </div>
                            
                        </div>
                        <div class="filters tabs_dockview container-fluid w-100 d-block px-0 mt-2">
                            <div class="row">
                            <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1 pr-0">
                                <label class="input_label">From Date</label>
                                <date-picker placeholder="From Date" v-model="search.start_date" valueType="format" class="startdate w-100 dashboard_date_box" @input="getGateParkingPerformanceData(null, false, true)"></date-picker>
                            </div>
                            <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1 pr_0_ds">
                                <label class="input_label">To Date</label>
                                <date-picker placeholder="To Date" v-model="search.end_date" valueType="format" class="startdate w-100 dashboard_date_box" @input="getGateParkingPerformanceData(null, false, true)"></date-picker>
                            </div>
                            <div class="w-auto px-1">
                                <div class="d-flex monthly_details_tab">
                                    <div @click="getGateParkingPerformanceData('today', true)" class="filter-btn active mr-2"><button>Today</button></div>
                                    <div @click="getGateParkingPerformanceData('week', true)" class="filter-btn mr-2"><button>Week</button></div>
                                    <div @click="getGateParkingPerformanceData('month', true)" class="filter-btn mr-2"><button>Month</button></div>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div class="collapse-margin collapse-icon mt-0" id="faq-cancellation-qna">
                            <div class="card border rounded mb-1 mt-0 " >
                                <div class="card-header bg-white" >
                                    <span class="lead collapse-title">
                                        Gate & Parking Performance
                                    </span>
                                </div>

                                <div id="faq-cancellation-one" class="" aria-labelledby="cancellationOne" data-parent="#faq-cancellation-qna">
                                    <div class="table-responsive mb-0" >  
                                        <table class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable " aria-describedby="mydesc">
                                            <thead 
                                            class="header-primary">
                                            <tr class="thfirst_dock_performance">
                                                    <th scope="col" class="text-left" style="min-width:255px;" >Truck Types</th>
                                                    <template v-for="(head, idx) in gateParkingPerformanceData.vehicle_size">
                                                        <th scope="col" class="text-center">{{head.vehicle_size}}</th>
                                                    </template>
                                                </tr>
                                            </thead>
                                        <tbody>
                                            <vue-element-loading :active="isGateParkingPerformanceDataLoading" spinner="bar-fade-scale" />  
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Total Entry / Exited Trucks Count</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{getDataPoint(gateParkingPerformanceData.total_entry_exit_trucks_count.find(h => h.vehicle_size == dataPoint.vehicle_size))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Gate Wait Time</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertMinutesToTime2(getDataPoint(gateParkingPerformanceData.avg_gate_wait_time.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Parking Wait Time</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertMinutesToTime2(getDataPoint(gateParkingPerformanceData.avg_parking_wait_time.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Gate Entry to Gate Exit Time</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertMinutesToTime2(getDataPoint(gateParkingPerformanceData.avg_gate_entry_to_gate_exit_time.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Daily Avg. Gate Entry Trucks Count</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertToInteger(getDataPoint(gateParkingPerformanceData.daily_avg_gate_entry_trucks_count.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Daily Avg. Gate Exit Trucks Count</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertToInteger(getDataPoint(gateParkingPerformanceData.daily_avg_gate_exit_trucks_count.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Trucks Count In Parking</td>
                                                <template v-for="(dataPoint, idx2) of gateParkingPerformanceData.vehicle_size">
                                                    <td class="text-center">
                                                        {{convertToInteger(getDataPoint(gateParkingPerformanceData.avg_trucks_count_in_parking.find(h => h.vehicle_size == dataPoint.vehicle_size)))}}
                                                    </td>
                                                </template>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card card  rounded mb-1" >
                                <div class="card-header bg-white custom-header_titile_card_header" >
                                    <span class="lead collapse-title">Parking high wait time Trucks</span>
                                </div>
                                <div id="faq-cancellation-two" class="" aria-labelledby="cancellationTwo" data-parent="#faq-cancellation-qna">
                                    <div class="table-responsive datatableview mb-0">      
                                        <table class="table table-striped  project_name_member_text_01 custom_doctable custom_tablecolumn_dock " aria-describedby="mydesc">
                                            <thead 
                                            class="header-primary">
                                            <tr>
                                                <th scope="col" class="text-left" style="width: 255px;">Parking high wait time <br/> Trucks and Drivers</th>
                                                <th scope="col" class="text-center align-middle">Gate Entry Date / Time </th>
                                                <th scope="col" class="text-center align-middle">Parking Wait Time </th>
                                                <th scope="col" class="text-center align-middle">Action</th>
                                                <th scope="col" class="text-center align-middle">Truck and Driver Photo</th>
                                            </tr>    
                                            </thead>
                                        <tbody>
                                            <vue-element-loading :active="isParkingHighWaitTimeTrucksLoading" spinner="bar-fade-scale" />
                                            <template v-for="(data,index) in parkingHighWaitTimeTrucks.list"  >
                                                <tr class=" ">
                                                    <td data-column="Parking high wait time Trucks and Drivers" class="text-left  merge_column_detals">
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Truck Number Plate : </span>
                                                            <span class="title_value_text">{{data.vehicle_number_plate}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Driver Name : </span>
                                                            <span class="title_value_text"> XXXX</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Truck Type : </span>
                                                            <span class="title_value_text"> {{data.vehicle_size}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Total Shipments : </span>
                                                            <span class="title_value_text"> {{getTotalShipments('parkingHighWaitTimeTrucks', data.trip_number)}} </span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Total Weight : </span>
                                                            <span class="title_value_text"> {{getTotalWeight('parkingHighWaitTimeTrucks', data.trip_number)}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Allocated Dock No : </span>
                                                            <span class="title_value_text"> {{data.dock_name ? data.dock_name : "Not Allocated"}}</span>
                                                        </div>
                                                    </td>
                                                    <td data-column="Gate Entry Date / Time" class="text-center">{{dateWithAmPm(data.gate_entry_time)}}</td>
                                                    <td data-column="Driver Name" class="text-center">{{data.parking_wait_time}} Hr </td>
                                                    <td data-column="Action" class="text-center"><a href="tel:123456789">Call Executive</a></td>

                                                    <td data-column="Truck and Driver Photo" class="text-center">
                                                        <div class="daily_transaction_photos_details">
                                                            <ul>
                                                            <li> 
                                                                <div class="photo_details_doc_04"> 
                                                                    <div class="innerphoto_details_doc_04">
                                                                        <img alt=""  class="" :src="findImageUrl('parkingHighWaitTimeTrucks', data.vehicle_number_plate_photo)" @click="getPhotoLink(data.vehicle_number_plate_photo)" >
                                                                    </div>
                                                                    <h6 class="vehicle_name_text"> Truck /Driver Photo</h6>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        </div>
                                                        <!-- <span class="title_value_text"> <a href="#" @click="getPhotoLink(data.vehicle_number_plate_photo)">View Photo</a></span> -->
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-if="!parkingHighWaitTimeTrucks.list.length">
                                            <tr><td colspan="14" style="text-align: center;">No data to show</td></tr>
                                            </template>
                                        </tbody>
                                        </table>
                                    </div>
                                    <div class="pageCenter text-center mt-2 mb-1 pagination_viewallpages">
                                        <pagination v-model="parkingHighWaitTimeTrucks.page" :records="parkingHighWaitTimeTrucks.totalcount" :per-page="parkingHighWaitTimeTrucks.pagelimit" @paginate="(e) => handlePageChange(e, 'parkingHighWaitTimeTrucks')"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--  -->
                    <div role="tabpanel" class="tab-pane global_performance_tab_container" id="chart" aria-labelledby="dock_tab" aria-expanded="false">
                    <!-- <h4  class="customTitle pb-1 mb-0"> Dock Details</h4> -->
                        <section id="dashboard-ecommerce" class=" customAnimation">
                            <div class="row mx-0 match-height dshboard_margin_x customAnimation">
                                <div class="col-lg-12 col-12 dshboard_padd_x card p-0 mb-0">
                                <div class="jumbotron_bg dashboard_secondview px-1 pt-1 pb-0 white_bg">
                                 <div class="row match-height dashTiles dashTiles_icons mb-0 velmld-parent">
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-01" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/loading_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{convertMinutesToTime2(mainDockPerformanceData.avg_dock_loading_time)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Min</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg Dock Loading</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-02" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/unloading_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{convertMinutesToTime2(mainDockPerformanceData.avg_dock_unloading_time)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Min</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg. Dock Unloading</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-03" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exist_tat.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainDockPerformanceData.avg_dock_entry_to_dock_exit_tat)}}
                                                </span>
                                                <span class="avgGatetimeMi"> Hours</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg Dock Entry to Dock Exit TAT</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2" style="display: none;">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-03" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exist_tat.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{roundNumber(mainDockPerformanceData.dock_capacity)}}% 
                                                </span>
                                                <span class="avgGatetimeMi"> Occupied</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Dock Capacity</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-04 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainDockPerformanceData.daily_avg_dock_entry)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Daily Avg. Dock Entry</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-05 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainDockPerformanceData.daily_avg_dock_exit)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Daily Avg. Dock Exit</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6 col-sm-6  col-md-3 col-xl-2">
                                        <div class="card text-center my_projects-bgs_co performance_projects-bgs-06 mb-1" >
                                            <div class="gateperformanceicon">
                                                <div class="avatar bg-light-warning p-50 mb-1">
                                                    <div class="avatar-content avatar_iconsview">
                                                        <img alt=""  class="round" src="../../../public/images/icons/gate_exit_blk.svg">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="card-body card_crossdock_image  pt-0 pb-1 px-0">
                                               <div class="timeGatetimeview">
                                                <span class="avgGatetimeview">
                                                    {{Math.ceil(mainDockPerformanceData.avg_trucks_in_dock)}}
                                                </span>
                                                <span class="avgGatetimeMi"> trucks</span>
                                                </div>

                                                <h2 class="font-weight-bolder">Avg. Trucks in Dock</h2>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                </div>
                                </div>
                            </div>
                        </section>
                        <div class="filters2 tabs_dockview w-100 d-block px-0 mt-2">
                            <div class="row">
                            <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1 pr-0">
                                <label class="input_label">From Date</label>
                                <date-picker placeholder="From Date" v-model="search_dock_performance.start_date" valueType="format" class="startdate w-100 dashboard_date_box" @input="getDockParkingPerformanceData(null, false, true)"></date-picker>
                            </div>
                            <div class="col-6 col-sm-6 col-md-4 col-lg-4 mb-1 pr_0_ds">
                                <label class="input_label">To Date</label>
                                <date-picker placeholder="To Date" v-model="search_dock_performance.end_date" valueType="format" class="startdate w-100 dashboard_date_box" @input="getDockParkingPerformanceData(null, false, true)"></date-picker>
                            </div>
                            <div class="w-auto px-1">
                                <div class="d-flex monthly_details_tab">
                                    <div @click="getDockParkingPerformanceData('today', true)" class="filter-btn active"><button>Today</button></div>
                                    <div @click="getDockParkingPerformanceData('week', true)" class="filter-btn"><button>Week</button></div>
                                    <div @click="getDockParkingPerformanceData('month', true)" class="filter-btn"><button>Month</button></div>
                                </div>
                            </div>
                            </div>
                        </div>
                        <section class="dashTiles_padd_05view">
                            <div class="collapse-margin collapse-icon mt-0" id="faq-cancellation-qna">
                            <div class="card   rounded mb-1 mt-0 " >
                                <div class="card-header bg-white" >
                                    <span class="lead collapse-title">
                                    Docks Performance
                                    </span>
                                </div>

                                <div id="faq-cancellation-three" class="" aria-labelledby="cancellationthree" data-parent="#faq-cancellation-qna">
                                    <div class="table-responsive mb-0" >      
                                        <table class="table table-striped dataTableListing table-hover project_name_member_text_01 custom_doctable" aria-describedby="mydesc">
                                            <thead 
                                            class="header-primary">
                                            <tr class="topheader_dock_performance  thfirst_dock_performance">
                                                    <th scope="col" class="text-left" style="min-width: 320px;"></th>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <th scope="col" :colspan="dockParkingPerformanceData.vehicle_size.length" class="text-center">{{head.dock_name}}</th>
                                                    </template>
                                                </tr>
                                                <tr class=" thfirst_dock_performance">
                                                    <th scope="col" class="text-left">Trucks size (Feet)</th>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(subHead, idx2) in dockParkingPerformanceData.vehicle_size" >
                                                            <th scope="col" class="text-center">{{subHead.vehicle_size}}</th>
                                                        </template>
                                                    </template>
                                                </tr>
                                            </thead>
                                        <tbody>
                                            <vue-element-loading :active="isDockParkingPerformanceDataLoading" spinner="bar-fade-scale" />
                                            <tr class=" tdfirst_dock_performance">
                                            
                                                <td class="text-left" >Avg. Process Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_process_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Wait Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_wait_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Unloading Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_unloading_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Loading Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_loading_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Gate Entry Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_gate_entry_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Gate Exit Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_gate_exit_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Parking Time</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{convertMinutesToTime2(getDataPoint(dockParkingPerformanceData.avg_parking_time.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Truck Count</td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{roundNumber(getDataPoint(dockParkingPerformanceData.avg_truck_count.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Avg. Truck Door Open to Close Time </td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                -
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Total Weight </td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                {{roundNumber(getDataPoint(dockParkingPerformanceData.total_weight.find(h => h.vehicle_size == dataPoint.vehicle_size && h.dock_name === head.dock_name)))}}
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Total Volumetric Weight </td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                -
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                            <tr class=" tdfirst_dock_performance">
                                                <td class="text-left" >Total Stage Area Load </td>
                                                    <template v-for="(head, idx) in dockParkingPerformanceData.docks">
                                                        <template v-for="(dataPoint, idx2) of dockParkingPerformanceData.vehicle_size">
                                                            <td class="text-center">
                                                                -
                                                            </td>
                                                        </template>
                                                    </template>
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="card card  rounded mb-1" >
                                <div class="card-header bg-white" >
                                    <span class="lead collapse-title">Dock High Wait Time Trucks</span>
                                </div>
                                <div id="faq-cancellation-four" class="" aria-labelledby="cancellationFour" data-parent="#faq-cancellation-qna">
                                    <div class="table-responsive mb-0 datatableview">      
                                        <table class="table dataTableListing table-hover table-striped project_name_member_text_01 custom_doctable custom_tablecolumn_dock " aria-describedby="mydesc">
                                            <thead 
                                            class="header-primary">
                                            <tr>
                                                <th scope="col" class="text-left align-middle" style="min-width: 320px;">Dock high wait time <br/>Trucks and Drivers</th>
                                                <!-- <th scope="col" class="text-center align-middle">Dock Operation Type </th> -->

                                                <th scope="col" class="text-left align-middle" style="min-width: 300px;">Dock Operations  </th>
                                                
                                                <th scope="col" class="text-center align-middle">Total Shipment Unloaded </th>
                                                <th scope="col" class="text-center align-middle">Total Weight Unloaded </th>
                                                <th scope="col" class="text-center align-middle">Action </th>
                                            </tr>
                                            </thead>    
                                        <tbody>
                                            <vue-element-loading :active="isDockHighWaitTimeTrucksLoading" spinner="bar-fade-scale" />
                                            <template v-for="(data,index) in dockHighWaitTimeTrucks.list"  >
                                                <tr class=" ">
                                                    <td data-column='Dock high wait time Trucks and Drivers' class="text-left  merge_column_detals">
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Truck Number Plate : </span>
                                                            <span class="title_value_text">{{data.vehicle_number_plate}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Driver Name : </span>
                                                            <span class="title_value_text"> XXXX</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Truck Type : </span>
                                                            <span class="title_value_text"> {{data.vehicle_size}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Total Shipments : </span>
                                                            <span class="title_value_text"> - </span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Total Weight : </span>
                                                            <span class="title_value_text"> - </span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Allocated Dock No : </span>
                                                            <span class="title_value_text"> {{data.dock_name ? data.dock_name : "-"}}</span>
                                                        </div>
                                                    </td>
                                                    
                                                    
                                                    <td data-column='Dock Operations' class="text-left  merge_column_detals">
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Dock Operation Type : </span>
                                                            <span class="title_value_text">{{data.loading_type ? data.loading_type : "-"}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Dock Entry Date/ Time : </span>
                                                            <span class="title_value_text">{{dateWithAmPm(data.scan_in_time)}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Door Open Time : </span>
                                                            <span class="title_value_text">{{dateWithAmPm(data.scan_in_time)}}</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Dock Entry - Door Open time gap : </span>
                                                            <span class="title_value_text">{{data.wait_time}} Hr</span>
                                                        </div>
                                                        <hr>
                                                        <div class="meger_details">
                                                            <span class="title_name_text"> Total Dock Wait Time : </span>
                                                            <span class="title_value_text">{{data.wait_time}} Hr</span>
                                                        </div>
                                                    </td>
                                                    
                                                   
                                                    
                                                    
                                                    <td data-column='Total Shipment Unloaded' class="text-center">0 Kg </td>
                                                    <td data-column='Total Weight Unloaded' class="text-center">0 Kg </td>
                                                    <td data-column='Action' class="text-center"><a href="tel:123456789">Call Executive</a></td>
                                                </tr>
                                            </template>
                                            <template v-if="!dockHighWaitTimeTrucks.list.length">
                                            <tr><td colspan="100%" style="text-align: center;">No data to show</td></tr>
                                            </template>                                    
                                        </tbody>
                                        </table>
                                    </div>
                                    <div class="pageCenter text-center mt-2 mb-1 pagination_viewallpages">
                                        <pagination v-model="dockHighWaitTimeTrucks.page" :records="dockHighWaitTimeTrucks.totalcount" :per-page="dockHighWaitTimeTrucks.pagelimit" @paginate="(e) => handlePageChange(e, 'dockHighWaitTimeTrucks')"/>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                        </section>
                    </div>
                </div>
                </section>
            
            
                

                <!-- another div -->
               
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import moment from "moment";
import Pagination from 'vue-pagination-2'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css'
import Treeselect from '@riophae/vue-treeselect'
import VueElementLoading from 'vue-element-loading'
import { XCircleIcon, FileIcon, UploadIcon, DownloadIcon, EditIcon, XIcon } from 'vue-feather-icons';
import CONSTANT from "../../constants.js"
import { read, utils } from "xlsx";
// import schema from "../utils/schema";
import common_methods from "../../utils/common_methods"
import searchMasterNameList from "../../utils/searchMasterNameList"

export default({
    name:'CrossDockPerformance',
    mixins: [common_methods, searchMasterNameList],
    components: {
        Treeselect,
        DatePicker,
        VueElementLoading,
        Pagination,
        UploadIcon,
        FileIcon,
        XCircleIcon,
        DownloadIcon,
        EditIcon,
        XIcon,
    },
    data() {
        return {
            gateFilter: null,
            dockFilter: null,
            isLoading: false,
            isReportDataLoading: false,
            isReportActive: true,
            isGateMainPerformanceDataLoading: false,
            isGateParkingPerformanceDataLoading: false,
            isParkingHighWaitTimeTrucksLoading: false,
            isDockMainPerformanceDataLoading: false,
            isDockParkingPerformanceDataLoading: false,
            isDockHighWaitTimeTrucksLoading: false,
            reportData: [],
            photo_links: [],
            search: {
                end_date: null,
                start_date: null
            },
            search_dock_performance: {
                end_date: null,
                start_date: null
            },
            mainGatePerformanceData: {
              avg_gate_wait_time: 0,
              avg_parking_wait_time: 0,
              avg_gate_entry_to_gate_exit_tat: 0,
              parking_capacity: 0,
              daily_avg_gate_entry: 0,
              daily_avg_gate_exit: 0,
              avg_trucks_in_parking: 0
            },
            gateParkingPerformanceData: {
                "total_entry_exit_trucks_count": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "avg_gate_wait_time": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "avg_parking_wait_time": [
                    {
                        "vehicle_size": "122",
                        "datapoint": "0.3333"
                    },
                    {
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.6667"
                    },
                    {
                        "vehicle_size": "22",
                        "datapoint": "3.0000"
                    },
                    {
                        "vehicle_size": "22 FEET",
                        "datapoint": "538.6429"
                    },
                    {
                        "vehicle_size": "Compact",
                        "datapoint": "0.0000"
                    },
                    {
                        "vehicle_size": "Large",
                        "datapoint": "13.5000"
                    },
                    {
                        "vehicle_size": "Medium",
                        "datapoint": "0.0000"
                    },
                    {
                        "vehicle_size": "Small",
                        "datapoint": null
                    }
                ],
                "avg_gate_entry_to_gate_exit_time": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "daily_avg_gate_entry_trucks_count": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "daily_avg_gate_exit_trucks_count": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "avg_trucks_count_in_parking": [
                    {
                        "vehicle_size": "14 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "18 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "40 FEET",
                        "datapoint": 0
                    },
                    {
                        "vehicle_size": "48 FEET",
                        "datapoint": 0
                    },
                ],
                "vehicle_size": [
                    {
                        "vehicle_size": "14 FEET"
                    },
                    {
                        "vehicle_size": "18 FEET"
                    },
                    {
                        "vehicle_size": "40 FEET"
                    },
                    {
                        "vehicle_size": "48 FEET"
                    },
                ]
            },
            parkingHighWaitTimeTrucks: {
                url: "/reports/gate-performance/parking-high-wait-time-trucks",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
                shipments: [],
                presignedUrls: [],
            },
            mainDockPerformanceData: {
                avg_dock_loading_time: 0,
                avg_dock_unloading_time: 0,
                avg_dock_entry_to_dock_exit_tat: 0,
                dock_capacity: 0,
                daily_avg_dock_entry: 0,
                daily_avg_dock_exit: 0,
                avg_trucks_in_dock: 0
            },
            dockParkingPerformanceData: {
                "avg_process_time": [
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "3",
                        "datapoint": "4.5000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Big",
                        "datapoint": "8.3333"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Small",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "9.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Big",
                        "datapoint": "1422.7500"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "2 FEET",
                        "datapoint": "44.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "22 FEET",
                        "datapoint": "9.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Compact",
                        "datapoint": "-0.2500"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "22 feet",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Compact",
                        "datapoint": "688.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Small",
                        "datapoint": "431.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Big",
                        "datapoint": "5.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Compact",
                        "datapoint": "17.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Medium",
                        "datapoint": "9.6667"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Small",
                        "datapoint": "196.0000"
                    },
                    {
                        "dock_name": "Dock 3",
                        "vehicle_size": "Medium",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22 FEET",
                        "datapoint": "26.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Big",
                        "datapoint": "2.5000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": null,
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "22 FEET",
                        "datapoint": "9.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "3",
                        "datapoint": "16.5000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Big",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Compact",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "10 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 feet",
                        "datapoint": "0.2500"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Big",
                        "datapoint": "5.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Compact",
                        "datapoint": "20.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Small",
                        "datapoint": "27.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.5000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "MAAO",
                        "vehicle_size": "3",
                        "datapoint": "7.3333"
                    }
                ],
                "avg_wait_time": [
                    {
                        "dock_name": "DAS",
                        "vehicle_size": "Big",
                        "datapoint": "33.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22",
                        "datapoint": "0.5000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Big",
                        "datapoint": "1078.2500"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Big",
                        "datapoint": "2.3333"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Small",
                        "datapoint": "3.5000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Compact",
                        "datapoint": "1.5000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Small",
                        "datapoint": "403.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "22 FEET",
                        "datapoint": "4.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Compact",
                        "datapoint": "2.5000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Small",
                        "datapoint": "23055.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": null,
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Big",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Compact",
                        "datapoint": "-15.3333"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Medium",
                        "datapoint": "8.5000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 3",
                        "vehicle_size": "Medium",
                        "datapoint": "1164.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22 FEET",
                        "datapoint": "20.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Compact",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Small",
                        "datapoint": "354.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": null,
                        "datapoint": "22.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "22 FEET",
                        "datapoint": "8.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Big",
                        "datapoint": "3.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Compact",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "10 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22",
                        "datapoint": "2.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 feet",
                        "datapoint": "1.7500"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Big",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Compact",
                        "datapoint": "6.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "MAAO",
                        "vehicle_size": "3",
                        "datapoint": "3.0000"
                    }
                ],
                "avg_loading_time": [
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.3333"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 feet",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    }
                ],
                "avg_unloading_time": [
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 feet",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "17.6667"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    }
                ],
                "avg_gate_entry_time": [
                    {
                        "dock_name": "DAS",
                        "vehicle_size": "Big",
                        "datapoint": "17321.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "2 FEET",
                        "datapoint": "3.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22",
                        "datapoint": "-148.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 FEET",
                        "datapoint": "3.2500"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "3",
                        "datapoint": "6.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Big",
                        "datapoint": "1081.2500"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Small",
                        "datapoint": "1.5000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22",
                        "datapoint": "6.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "3",
                        "datapoint": "10.5000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Big",
                        "datapoint": "4321.7500"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Small",
                        "datapoint": "5.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Compact",
                        "datapoint": "5.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Small",
                        "datapoint": "23519.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "22 FEET",
                        "datapoint": "12.5000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Compact",
                        "datapoint": "2206.5000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Small",
                        "datapoint": "23112.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": null,
                        "datapoint": "18254.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "2 FEET",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "22 FEET",
                        "datapoint": "3669.5000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Big",
                        "datapoint": "7.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Compact",
                        "datapoint": "10919.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Medium",
                        "datapoint": "9.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Small",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock 3",
                        "vehicle_size": "Medium",
                        "datapoint": "1166.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22",
                        "datapoint": "-149.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22 FEET",
                        "datapoint": "9743.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "3",
                        "datapoint": "7.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Big",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Compact",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "14.5000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Small",
                        "datapoint": "355.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": null,
                        "datapoint": "18253.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "22 FEET",
                        "datapoint": "10.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Big",
                        "datapoint": "17285.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Compact",
                        "datapoint": "0.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "10 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22",
                        "datapoint": "-70.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 feet",
                        "datapoint": "4389.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "3",
                        "datapoint": "5.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Big",
                        "datapoint": "10.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Compact",
                        "datapoint": "6.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Small",
                        "datapoint": "3.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "18.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "3",
                        "datapoint": "22.5000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "MAAO",
                        "vehicle_size": "3",
                        "datapoint": "11.0000"
                    }
                ],
                "avg_gate_exit_time": [
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "2 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Big",
                        "datapoint": "9.3333"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Small",
                        "datapoint": "0.5000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "65.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Big",
                        "datapoint": "1078.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "2 FEET",
                        "datapoint": "64.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "22 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Compact",
                        "datapoint": "8.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "22 feet",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Compact",
                        "datapoint": "50.5000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Small",
                        "datapoint": "836.5000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "2 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "22 FEET",
                        "datapoint": "66.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Big",
                        "datapoint": "4.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Compact",
                        "datapoint": "83.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Medium",
                        "datapoint": "2894.3333"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Small",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 3",
                        "vehicle_size": "Medium",
                        "datapoint": "4347.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22 FEET",
                        "datapoint": "5.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "3",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Big",
                        "datapoint": "637.5000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": null,
                        "datapoint": "350.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "22 FEET",
                        "datapoint": "427.5000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "3",
                        "datapoint": "744.2500"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Big",
                        "datapoint": "1376.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Compact",
                        "datapoint": "11579.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "10 FEET",
                        "datapoint": "0.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 FEET",
                        "datapoint": "466.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Big",
                        "datapoint": "0.5000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Compact",
                        "datapoint": "38.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "3",
                        "datapoint": "44.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "Small",
                        "datapoint": "29.0000"
                    },
                    {
                        "dock_name": "MAAO",
                        "vehicle_size": "3",
                        "datapoint": "27.0000"
                    }
                ],
                "avg_parking_time": [
                    {
                        "result": 2
                    }
                ],
                "avg_truck_count": [
                    {
                        "dock_name": "DAS",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "122",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "2 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "22 FEET",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Big",
                        "datapoint": "1.3333"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Large",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC XX",
                        "vehicle_size": "Small",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "22 FEET",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOC YY",
                        "vehicle_size": "Small",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "2 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Compact",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "DOCK 00X",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Compact",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 1",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": null,
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "122",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "2 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Compact",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Medium",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 2",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 3",
                        "vehicle_size": "Medium",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Compact",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Large",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 4 Up",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": null,
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "22 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "3",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock 5",
                        "vehicle_size": "Compact",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "10 FEET",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "22 feet",
                        "datapoint": "1.3333"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "3",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Big",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Compact",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock A001",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "22 FEET",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "3",
                        "datapoint": "2.0000"
                    },
                    {
                        "dock_name": "Dock Park",
                        "vehicle_size": "Small",
                        "datapoint": "1.0000"
                    },
                    {
                        "dock_name": "MAAO",
                        "vehicle_size": "3",
                        "datapoint": "3.0000"
                    }
                ],
                "avg_truck_door_open_to_close_time": [
                    {
                        "result": 2
                    }
                ],
                "total_weight": [
                    {
                        "result": 2
                    }
                ],
                "total_volumetric_weight": [
                    {
                        "result": 2
                    }
                ],
                "total_stage_area_load": [
                    {
                        "result": 2
                    }
                ],
                "vehicle_size": [
                    {
                        "vehicle_size": "Compact"
                    },
                    {
                        "vehicle_size": "Large"
                    },
                    {
                        "vehicle_size": "Medium"
                    },
                    {
                        "vehicle_size": "Small"
                    },
                    {
                        "vehicle_size": "Big"
                    },
                    {
                        "vehicle_size": "22 FEET"
                    },
                    {
                        "vehicle_size": "3"
                    },
                    {
                        "vehicle_size": "2 FEET"
                    },
                    {
                        "vehicle_size": "10 FEET"
                    },
                    {
                        "vehicle_size": "22"
                    },
                    {
                        "vehicle_size": "122"
                    }
                ],
                "docks": [
                    {
                        "dock_name": "Dock 1"
                    },
                    {
                        "dock_name": "Dock 2"
                    },
                    {
                        "dock_name": "Dock 3"
                    },
                    {
                        "dock_name": "Dock 4 Up"
                    },
                    {
                        "dock_name": "Dock 5"
                    },
                    {
                        "dock_name": "DOC XX"
                    },
                    {
                        "dock_name": "DOC YY"
                    },
                    {
                        "dock_name": "DOCK 00X"
                    },
                    {
                        "dock_name": "Dock A001"
                    },
                    {
                        "dock_name": "DAS"
                    },
                    {
                        "dock_name": "MAAO"
                    },
                    {
                        "dock_name": "Dock Park"
                    },
                    {
                        "dock_name": "MAAO2"
                    },
                    {
                        "dock_name": "SLMO/CJB"
                    },
                    {
                        "dock_name": "BLRO"
                    },
                    {
                        "dock_name": "HYDO"
                    },
                    {
                        "dock_name": "NAGO/RPR"
                    },
                    {
                        "dock_name": "PATO"
                    },
                    {
                        "dock_name": "CCUO/NJP/GUAO"
                    },
                    {
                        "dock_name": "AMDI/BDQN/SRT"
                    },
                    {
                        "dock_name": "HBL/BGM"
                    },
                    {
                        "dock_name": "BOMD"
                    },
                    {
                        "dock_name": "JSPO"
                    },
                    {
                        "dock_name": "AMCO"
                    },
                    {
                        "dock_name": "DELH"
                    },
                    {
                        "dock_name": "NDAO/LKOD"
                    },
                    {
                        "dock_name": "IDRO"
                    },
                    {
                        "dock_name": "JAIO/UDR"
                    },
                    {
                        "dock_name": "PNQC"
                    },
                    {
                        "dock_name": "PNQI/PNQP"
                    },
                    {
                        "dock_name": "PNQW"
                    },
                    {
                        "dock_name": "PHR/JJR/BAR"
                    },
                    {
                        "dock_name": "STR/SWL"
                    },
                    {
                        "dock_name": "SVN"
                    },
                    {
                        "dock_name": "PNQE"
                    },
                    {
                        "dock_name": "GOI"
                    },
                    {
                        "dock_name": "ANR/RNJ"
                    },
                    {
                        "dock_name": "SPR/KKB"
                    },
                    {
                        "dock_name": "DUL/SNN/NSK"
                    },
                    {
                        "dock_name": "IXUE/IXUW"
                    },
                    {
                        "dock_name": "KOP"
                    },
                    {
                        "dock_name": "DUL"
                    },
                    {
                        "dock_name": "PNQN"
                    },
                    {
                        "dock_name": "PNQN1 "
                    },
                    {
                        "dock_name": "PNQN2"
                    }
                ]
            },
            dockHighWaitTimeTrucks: {
                url: "/reports/dock-performance/dock-high-wait-time-trucks",
                list: [],
                totalcount: 0,
                pageCount: 0,
                page: 1,
                pagelimit: CONSTANT.LIMIT,
                currPageNum: 0,
                pageoffset: 1,
                shipments: [],
                presignedUrls: [],
            }
        }
    } ,
    mounted(){
        this.runScript()
        this.getMainPerformanceDashBoardData()
        this.getGateParkingPerformanceData("today")
        this.getParkingHighWaitTimeTrucks()
        this.getDockMainPerformanceDashBoardData()
        this.getDockParkingPerformanceData("today")
        this.getDockHighWaitTimeTrucks()
    },
    methods: {
        getTotalShipments(tab, trip_number) {
            let shipments = this[tab].shipments
            let details = shipments.find(obj => obj.trip_number == trip_number)
            if(details) return details.no_of_pkg_in_vehicle
            return "-"
        },
        getTotalWeight(tab, trip_number) {
            let shipments = this[tab].shipments
            let details = shipments.find(obj => obj.trip_number == trip_number)
            if(details) return `${this.roundNumber(details.weight)} KG`
            return "-"
        },
        findImageUrl(tab, key) {
            let presignedUrls = this[tab].presignedUrls
            let urlObj = presignedUrls.find(obj => obj.fileKey === key)
            if(urlObj)  return urlObj.url
            return ""
        },
        runScript() {
            let elements = document.querySelectorAll(".filters .filter-btn")
            for(let element of elements) {
                element.addEventListener('click', (e) => {
                    for(let eachElement of elements) {
                        eachElement.classList.remove("active")
                    }
                    let filterDiv = element.closest(".filter-btn");
                    filterDiv.classList.add("active");
                })
            }
            let elements2 = document.querySelectorAll(".filters2 .filter-btn")
            for(let element of elements2) {
                element.addEventListener('click', (e) => {
                    for(let eachElement of elements2) {
                        eachElement.classList.remove("active")
                    }
                    let filterDiv = element.closest(".filter-btn");
                    filterDiv.classList.add("active");
                })
            }
        },
        removeTabActive() {
            let elements = document.querySelectorAll(".filters .filter-btn")
            for(let element of elements) {
                element.classList.remove("active")
            }
        },
        removeDockTabActive() {
            let elements = document.querySelectorAll(".filters2 .filter-btn")
            for(let element of elements) {
                element.classList.remove("active")
            }
        },
        activateReport() {
            this.isReportActive = true
        },
        deActivateReport() {
            this.isReportActive = false
        },
        getMainPerformanceDashBoardData() {
            this.isGateMainPerformanceDataLoading = true
            let url = "/reports/gate-performance/main"
            this.makeRequest("GET", url)
            .then(result => {
                this.isGateMainPerformanceDataLoading = false
                this.mainGatePerformanceData= result.data
            })
            .catch(e => {
                this.isGateMainPerformanceDataLoading = false
                this.displayError(e)
            })
        },
        getGateParkingPerformanceData(filter, clearDateFilter, removeTabActive) {
            if(clearDateFilter) {
                this.search.start_date = null
                this.search.end_date = null
            }
            if(removeTabActive) {
                this.removeTabActive()
            }
            if(!removeTabActive && filter === this.gateFilter) {
                this.gateFilter = filter
                return 
            }
            this.isGateParkingPerformanceDataLoading = true
            let url = `/reports/gate-performance/parking-data`
            if(filter) {
                url += `?filter=${filter}`
            }
            this.makeRequest("POST", url, this.search)
            .then(result => {
                this.isGateParkingPerformanceDataLoading = false
                this.gateParkingPerformanceData= result.data
            })
            .catch(e => {
                this.isGateParkingPerformanceDataLoading = false
                this.displayError(e)
            })
        },
        getParkingHighWaitTimeTrucks() {
            this.isParkingHighWaitTimeTrucksLoading = true
            let url = this.parkingHighWaitTimeTrucks.url
            let payload = {
                page: this.parkingHighWaitTimeTrucks.page,
                rows: this.parkingHighWaitTimeTrucks.pagelimit
            }
            this.makeRequest("POST", url, payload)
            .then(result => {
                this.isParkingHighWaitTimeTrucksLoading = false
                this.parkingHighWaitTimeTrucks.list = result.data.data.rows
                this.parkingHighWaitTimeTrucks.totalcount = result.data.data.count
                this.parkingHighWaitTimeTrucks.shipments = result.data.data.shipments
                this.parkingHighWaitTimeTrucks.presignedUrls = result.data.data.presignedUrls
                this.parkingHighWaitTimeTrucks.pageCount = Math.ceil(result.data.data.count / this.parkingHighWaitTimeTrucks.pagelimit)
            })
            .catch(e => {
                this.isParkingHighWaitTimeTrucksLoading = false
                this.displayError(e)
            })
        },
        getDockMainPerformanceDashBoardData() {
            this.isDockMainPerformanceDataLoading = true
            let url = "/reports/dock-performance/main"
            this.makeRequest("GET", url)
            .then(result => {
                this.isDockMainPerformanceDataLoading = false
                this.mainDockPerformanceData = result.data
            })
            .catch(e => {
                this.isDockMainPerformanceDataLoading = false
                this.displayError(e)
            })
        },
        getDockParkingPerformanceData(filter, clearDateFilter, removeTabActive) {
            if(clearDateFilter) {
                this.search_dock_performance.start_date = null
                this.search_dock_performance.end_date = null
            }
            if(removeTabActive) {
                this.removeDockTabActive()
            }
            if(!removeTabActive && filter === this.dockFilter) {
                this.dockFilter = filter
                return 
            }
            this.isDockParkingPerformanceDataLoading = true
            let url = `/reports/dock-performance/parking-data?filter=${filter}`
            this.makeRequest("POST", url, this.search)
            .then(result => {
                this.isDockParkingPerformanceDataLoading = false
                this.dockParkingPerformanceData= result.data
            })
            .catch(e => {
                this.isDockParkingPerformanceDataLoading = false
                this.displayError(e)
            })
        },
        getDockHighWaitTimeTrucks() {
            this.isDockHighWaitTimeTrucksLoading = true
            let url = this.dockHighWaitTimeTrucks.url
            let payload = {
                page: this.dockHighWaitTimeTrucks.page,
                rows: this.dockHighWaitTimeTrucks.pagelimit
            }
            this.makeRequest("POST", url, payload)
            .then(result => {
                this.isDockHighWaitTimeTrucksLoading = false
                this.dockHighWaitTimeTrucks.list = result.data.data.rows
                this.dockHighWaitTimeTrucks.totalcount = result.data.data.count
                this.dockHighWaitTimeTrucks.pageCount = Math.ceil(result.data.data.count / this.dockHighWaitTimeTrucks.pagelimit)
            })
            .catch(e => {
                this.isDockHighWaitTimeTrucksLoading = false
                this.displayError(e)
            })
        },
        getReports(tab) {
            if(tab === "parkingHighWaitTimeTrucks") {
                this.getParkingHighWaitTimeTrucks()
            } else if(tab === "dockHighWaitTimeTrucks") {
                this.getDockHighWaitTimeTrucks()
            }
        },
        handlePageChange(pageNum, tab) {
            this[tab].pageoffset=pageNum
            this[tab].currPageNum = pageNum - 1

            this.getReports(tab);
            setTimeout(() => {
                $('html, body').animate({
                  scrollTop: $(`#${tab}`).offset().top -70
                });
            }, 500);
        },
        getPhotoLink(key) {
            this.getPresignUrl(key)
                .then(result => {
                    this.photo_links = [ result ]
                    // $('.imagepreview').attr('src', this.photo_link);
                    $('#imagemodal').modal('show');
                })
                .catch(e => {
                    $('#imagemodal').modal('hide');
                    this.displayError(e)
                    this.photo_links = []
                })
        },
        
    }
})
</script>
<style scoped>
.filters, .filters2 {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.5rem;
        margin-bottom: 8px;
}

.filters button, .filters2 button {
    background: none;
    border: none;
    font-weight: 500;
    letter-spacing: 0.3px;
    border-radius: 2px;
    padding:3px  5px!important;
}

/* .filters button:hover, .filters2 button:hover {
    background-color: #00bcd4;
    color: #fff
} */

/* .tabs_dockview .active {
    border-bottom: 2px solid #03A9F4;
} */
.tabs_dockview .active button {
    background: #FF9800;
    color: #fff;
}
.innerphoto_details_doc_04{
    width: 140px;
    display: flex;
    border-bottom: 1px solid #DBDBDB;
    max-height: 140px;
    min-height: 140px;
    align-items: center;
    margin: 0px auto;
    overflow: hidden;
}
</style>